export const PUBLIC_CHANNEL_TYPES = ['general'] as const;

export const isPublicChannel = (channelType?: string) => {
  if (!channelType) {
    return false;
  }
  return PUBLIC_CHANNEL_TYPES.includes(channelType as any);
};
